/**
 * notifiche.js — UNA strada per dire qualcosa all'utente da qualunque
 * punto dell'applicazione, al posto di alert().
 *
 * PERCHE' NON alert(). In alcuni contesti (finestra in secondo piano,
 * tablet, popup gia' aperto) non compare affatto, e il tasto sembra
 * semplicemente non funzionare; e comunque copre la pagina. Ma il
 * difetto vero, trovato il 21 settembre 2026, era un altro: 17 dei 47
 * alert() del frontend buttavano via il messaggio del server e
 * scrivevano «Errore». Un 429 con il tempo di attesa compariva come
 * «Credenziali non valide», e ci si e' persa un'ora.
 *
 * QUINDI: il messaggio viene dal server quando c'e' (messaggioDa), e il
 * ripiego e' l'ultima risorsa. Una notifica elegante che dice «Errore»
 * e' lo stesso difetto con un vestito nuovo.
 *
 * Il disegno e' lo stesso dei riquadri in pagina (rm-messaggio); si
 * accoda in alto a destra, gli avvisi spariscono da soli, gli errori
 * restano finche' non si chiudono.
 */
import { create } from 'zustand';

export const useNotifiche = create((set) => ({
    voci: [],
    aggiungi: (voce) => set((s) => ({ voci: [...s.voci, voce] })),
    togli: (id) => set((s) => ({ voci: s.voci.filter((v) => v.id !== id) })),
}));

let progressivo = 0;

function notifica(tipo, testo, durata) {
    const t = String(testo || '').trim();
    if (!t) return;
    const id = ++progressivo;
    useNotifiche.getState().aggiungi({ id, tipo, testo: t });
    if (durata) setTimeout(() => useNotifiche.getState().togli(id), durata);
}

/** Un errore: resta finche' non lo si chiude. */
export const notificaErrore = (testo) => notifica('errore', testo, 0);
/** Un avviso (attenzione): otto secondi. */
export const notificaAvviso = (testo) => notifica('attenzione', testo, 8000);
/** Una conferma: quattro secondi. */
export const notificaConferma = (testo) => notifica('conferma', testo, 4000);

/**
 * Il messaggio da mostrare per un errore di rete: PRIMA quello del
 * server, poi quello dell'eccezione, poi il ripiego. Il ripiego e' un
 * segno che il server non ha detto niente: quelle rotte vanno corrette.
 */
export function messaggioDa(e, ripiego) {
    const dalServer = e?.response?.data?.message;
    if (dalServer && String(dalServer).trim()) return String(dalServer);
    if (e?.response?.status === 429 && e?.response?.data?.riapre_fra_secondi) {
        return `Troppe richieste: riprova fra ${e.response.data.riapre_fra_secondi} secondi.`;
    }
    if (e?.message && !/^Request failed with status code/.test(e.message)) return e.message;
    return ripiego || 'Errore';
}
